import { Observable, of } from 'rxjs';
import { Container, Service, history } from '../../../../symphony';

import { SlDataService } from '../sl-data.service';
import { getIsDark } from '../../utils/storageManager';
import { lePlaygroundContext } from '../../global-constants';

@Service()
export class SlCommonService {
	private dataService = Container.take(lePlaygroundContext.value, SlDataService);

	public initPlayground = (data): Observable<null> => {
		this.dataService.topLevelDomain$.next(data.topLevelDomain);
		const isDark = getIsDark();
		this.dataService.isDarkMode$.next(isDark);
		return of(null);
	};

	public makeFreeze = (): Observable<null> => {
		this.dataService.freezeLayer$.next(true);
		return of(null);
	};

	public resetContainer = (): Observable<null> => {
		const {
			cssCode$,
			jsCode$,
			sourceCode$,
			output$,
			isWeb$,
			codeData$,
			codeName$,
			showConfirmLeaveAlert$,
		} = this.dataService;

		isWeb$.next(false);
		output$.next(null);
		codeData$.next(null);
		cssCode$.next('');
		jsCode$.next('');
		sourceCode$.next('');
		codeName$.next('');
		showConfirmLeaveAlert$.next(false);
		return of(null);
	};

	public navigate = (url: string): Observable<null> => {
		history.push(url);
		return of(null);
	};
}
